import axios from "axios";
import { getBasicHeaders } from "./utils";

export const axiosPost = async (url, header = {}, requestBody, cancelToken) => {
    return axios({
        url,
        headers: { ...getBasicHeaders(), header },
        method: 'POST',
        data: requestBody,
        cancelToken,
    });
};
